angular.
module("dx.webapp.printing").
constant("DX_PRINT_SETTINGS", (function iife() {
	"use strict";

	var settings = {
		DOUBLE_LINE_SPACING: 2,
		BLANK_PAGE: 4,
		SKIP_UNANSWERED_QUESTIONS: 8,
		HIDE_STUDENT_NAMES: 16,
		SHOW_NAME: 32,
		SHOW_EMAIL: 64,
		SHOW_STUDENT_CODE: 128,
	};

	// If you set the DEFAULT to anything else than 'none' (0) use the enum to get
	// the values so it's easier to see what the default is set to.
	// For example: settings.DEFAULT = settings.FOO + settings.BAR;
	settings.DEFAULT = settings.SHOW_NAME;

	return Object.freeze(settings);
}()));
